// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"279":"component---src-pages-index-jsx","415":"component---src-pages-404-jsx"}[chunkId] || chunkId) + "-" + {"279":"b7f32f6f597f70e65ac4","391":"23819b821870106574c7","415":"ff39c8b1afb9751ff13b"}[chunkId] + ".js";
};